module.exports = __webpack_public_path__ + "static/media/Fontana_DKGrey.83971643.jpg";